// ./pages/About/index.jsx
import React from "react";
import Thankyousubbanner from "../../components/thankyousubbanner";

const Thankyou = () => {
  return (
    <>
    <Thankyousubbanner />
    </>
  );
};

export default Thankyou;